// @ts-nocheck
/* Port of ReleaseHero.js (39L). BYTE-IDENTICAL. */
import React from 'react';
import { formatReleaseDate } from './releaseUtils';

const ReleaseHero = ({ stats }: any) => {
  const items = [
    {
      label: 'Latest Version',
      value: stats?.latest_version ? `v${stats.latest_version}` : '—',
    },
    {
      label: 'Latest Release',
      value: formatReleaseDate(stats?.latest_release_date),
    },
    { label: 'Total Releases', value: stats?.total_releases ?? 0 },
    {
      label: 'Pinned Release',
      value: stats?.pinned_release?.version
        ? `v${stats.pinned_release.version}`
        : 'None',
    },
  ];

  return (
    <div className="rc-hero">
      <span className="rc-hero__eyebrow">✦ Product Updates</span>
      <h1 className="rc-hero__title">Release Notes</h1>
      <p className="rc-hero__subtitle">
        Everything we ship, in one place. Track new features, improvements and
        fixes across the platform — transparent, continuous, and built for you.
      </p>
      <div className="rc-hero__stats">
        {items.map((it: any) => (
          <div className="rc-stat" key={it.label}>
            <div className="rc-stat__label">{it.label}</div>
            <div className="rc-stat__value" title={String(it.value)}>
              {it.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReleaseHero;
